import { useContext, useId } from "react"

import FIELD_NAMES from "../../../../constant/fieldNames"
import type { OneClickFieldProps } from "../../../../types"
import FieldSet from "../../../components/1Click/FieldSet"
import OneClickFieldMessages from "../../../components/1Click/form/OneClickFieldMessages"
import ServiceCheckBox from "../../../components/1Click/form/ServiceCheckBox"
import PartsListUpload from "./PartsListUpload"
import OneClickEstimateContext from "../../../OneClickEstimateContext"

import designImage from "./design.png"
import manufactureImage from "./manufacture.png"
import mountImage from "./mount.png"
import procurementImage from "./procurement.png"
import AllSelectCheckBox from "./AllSelectCheckBox"

type ServiceSelectProps = OneClickFieldProps & {
  partsListError?: string
}

const ServiceSelect = ({ values, errors, handlers, partsListError }: ServiceSelectProps) => {
  const labelId = useId()
  const { partsListMapkey, setPartsListMapkey } = useContext(OneClickEstimateContext)

  const allSelected = values.serviceD && values.serviceM && values.serviceG && values.partsProcurementCourse

  const showPartsListDeletionDialog = (): boolean => {
    if (!partsListMapkey) {
      return true
    }
    const isConfirmed = window.confirm("部品調達の見積結果が削除されますがよろしいですか？")
    if (isConfirmed) {
      setPartsListMapkey("")
      sessionStorage.removeItem("partsListUpload")
    }
    return isConfirmed
  }

  return (
    <section className="mb-16">
      <div className="mb-4 flex items-center gap-2 align-middle">
        <h3 id={labelId} className="text-base font-bold text-[#32383e]">
          依頼する工程を選択
        </h3>
        <span className="text-sm text-neutral-500">※複数選択で同時に見積可能</span>
      </div>
      <FieldSet aria-labelledby={labelId}>
        <div className="mb-3">
          <AllSelectCheckBox
            checked={allSelected}
            onCheckedChange={(e) => {
              handlers.checkbox({
                target: { name: FIELD_NAMES.基板設計, checked: e.target.checked, type: "checkbox" },
              })
              handlers.checkbox({
                target: { name: FIELD_NAMES.基板製造, checked: e.target.checked, type: "checkbox" },
              })
              handlers.checkbox({
                target: { name: FIELD_NAMES.部品調達, checked: e.target.checked, type: "checkbox" },
              })
              handlers.checkbox({
                target: { name: FIELD_NAMES.部品実装, checked: e.target.checked, type: "checkbox" },
              })
            }}
          />
        </div>
        <div className="flex w-full items-center gap-3">
          <ServiceCheckBox
            className="flex-1"
            src={designImage}
            name={FIELD_NAMES.基板設計}
            checked={values.serviceD}
            onCheckedChange={handlers.checkbox}
          >
            基板設計
          </ServiceCheckBox>
          <ServiceCheckBox
            className="flex-1"
            src={manufactureImage}
            name={FIELD_NAMES.基板製造}
            checked={values.serviceM}
            onCheckedChange={handlers.checkbox}
          >
            基板製造
          </ServiceCheckBox>
          <ServiceCheckBox
            className="flex-1"
            src={procurementImage}
            name={FIELD_NAMES.部品調達}
            checked={values.partsProcurementCourse}
            onCheckedChange={(e) => {
              if (!e.target.checked && !showPartsListDeletionDialog()) {
                return
              }
              handlers.checkbox(e)
              if (e.target.checked) {
                handlers.checkbox({
                  target: { name: FIELD_NAMES.部品実装, checked: true, type: "checkbox" },
                })
              }
            }}
          >
            <div>
              <div>部品調達</div>
              <div className="text-[10px] leading-[1.66]">部品実装を選択の方のみ</div>
            </div>
          </ServiceCheckBox>
          <ServiceCheckBox
            className="flex-1"
            src={mountImage}
            name={FIELD_NAMES.部品実装}
            checked={values.serviceG}
            onCheckedChange={(e) => {
              if (!e.target.checked && !showPartsListDeletionDialog()) {
                return
              }
              handlers.checkbox(e)
              if (!e.target.checked) {
                handlers.checkbox({
                  target: { name: FIELD_NAMES.部品調達, checked: false, type: "checkbox" },
                })
              }
            }}
          >
            部品実装
          </ServiceCheckBox>
        </div>
        <OneClickFieldMessages error={errors?.serviceM} />
        {values.partsProcurementCourse && <PartsListUpload validationError={partsListError} />}
      </FieldSet>
    </section>
  )
}

export default ServiceSelect
